import * as React from 'react';
import './TrackingMobileCard.scss';
import TrackingModel from 'src/model/trackingInfo.model';

export interface ITrackingCardProps {
  headers: Array<{ label: string; sortBy: string; key: string }>;
  tracking: TrackingModel;
}

class TrackingCard extends React.Component<ITrackingCardProps, any> {
  private renderCard = () => {
    const { tracking } = this.props;
    const headers: JSX.Element[] = [];
    this.props.headers.map((header, index) => {
      headers.push(
        <div className="rp-mobile-tracking-card--data-container" key={index}>
          <div className="rp-mobile-tracking-card-column">
            <p className="header">{header.label}</p>
            {header.key === 'trackNumber' ? (
              <p
                className={tracking.trackingLink ? 'clickable' : 'data'}
                onClick={() => this.trackingRedirect(tracking)}
              >
                {`${tracking[header.key].substr(0, 5)}${tracking[
                  header.key
                ].substr(-2)}`}
              </p>
            ) : (
              <p className="data">{tracking[header.key]}</p>
            )}
          </div>
        </div>
      );
    });
    return headers;
  };

  private trackingRedirect = (tracking: TrackingModel) => {
    const { trackingLink } = tracking;
    if (trackingLink) {
      window.open(trackingLink, '_blank');
    }
    return;
  };

  public render() {
    return <div className="rp-mobile-tracking-card">{this.renderCard()}</div>;
  }
}

export default TrackingCard;
